import React, { Fragment } from 'react';
import { DatabaseIcon, HomeIcon, BarChart3Icon, BellIcon, CreditCardIcon, SettingsIcon, ChevronRightIcon, ArrowRightIcon, WifiIcon, UserIcon, AlertTriangleIcon, CheckCircle2Icon, ClipboardListIcon, Clock3Icon } from 'lucide-react';
import { capabilities, capabilityVisuals as v, productionCopy as c, WATER_PRODUCTION_IMAGES as IMG, type Bi, type CapabilityKey } from '../../../data/waterProduction';
type P = {
  isFR: boolean;
};
const ICONS: Record<CapabilityKey, typeof BellIcon> = {
  data: DatabaseIcon,
  identity: HomeIcon,
  insight: BarChart3Icon,
  notify: BellIcon,
  pay: CreditCardIcon,
  act: SettingsIcon
};
const BOX = 'rounded-xl border border-[#EEEEF4] bg-white';
function Visual({
  k,
  isFR
}: P & {
  k: CapabilityKey;
}) {
  const pick = (b: Bi) => isFR ? b.fr : b.en;
  if (k === 'data') return <div className="relative h-[140px]" data-id="element-7224" data-mp="2025buw64wkqq">
        <img src={IMG.meter} alt={pick(c.meterAlt)} className="w-full h-full object-cover rounded-xl" data-id="element-7225" data-mp="2012imhlca67n" />
        <span className="absolute -right-2 top-1/2 -translate-y-1/2 w-14 h-14 rounded-full bg-[#EEEDFD] border-4 border-white flex items-center justify-center" aria-hidden="true" data-id="element-7226" data-mp="lo3ypcn7nwup">
          <WifiIcon className="w-6 h-6 text-[#4F46E5]" strokeWidth={2.2} data-id="element-7227" data-mp="cnxmrv75v4xn" />
        </span>
      </div>;
  if (k === 'identity') return <ul className="space-y-1.5" data-id="element-7228" data-mp="7rqfnz313ne4">
        <li className={`${BOX} flex items-center gap-3 px-3.5 py-2.5`} data-id="element-7229" data-mp="2qawkckevqyd">
          <UserIcon className="w-4 h-4 text-[#4F46E5] shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-7230" data-mp="2sdudirt2odn" />
          <span data-id="element-7231" data-mp="3u3dvq6c8ubvm">
            <span className="block font-sans text-[12.5px] font-semibold text-[#121A3A]" data-id="element-7232" data-mp="3q3dhalp5a0ok">{pick(v.identity.person)}</span>
            <span className="block font-sans text-[11px] text-[#1F9D7A]" data-id="element-7233" data-mp="3l5bova5twp0f">{pick(v.identity.verified)}</span>
          </span>
        </li>
        {v.identity.properties.map(p => <li key={p.address.en} className={`${BOX} flex items-center gap-3 px-3.5 py-2.5 ml-4`} data-id="element-7234" data-mp="3b6miadjduqzh">
            <HomeIcon className="w-4 h-4 text-[#4F46E5] shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-7235" data-mp="31j0bqxru6tkp" />
            <span data-id="element-7236" data-mp="36icy7hespymr">
              <span className="block font-sans text-[12.5px] font-semibold text-[#121A3A]" data-id="element-7237" data-mp="36iv312fixl6a">{pick(p.address)}</span>
              <span className="block font-sans text-[11px] text-[#5B6478]" data-id="element-7238" data-mp="2sjdjb1h34y3s">{pick(p.meters)}</span>
            </span>
          </li>)}
      </ul>;
  if (k === 'insight') return <div className="rounded-xl bg-[#FDF3F3] p-3.5 h-[140px] flex flex-col" data-id="element-7239" data-mp="3kajdz2e1e3lo">
        <div className="flex gap-2.5" data-id="element-7240" data-mp="3p8kx1nbgq2x5">
          <AlertTriangleIcon className="w-5 h-5 text-[#E5484D] shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-7241" data-mp="3p7jk1davz6cs" />
          <span data-id="element-7242" data-mp="3betz7c73g7h9">
            <span className="block font-sans text-[13px] font-semibold text-[#D23B40]" data-id="element-7243" data-mp="3fii75vzn1531">{pick(v.insight.title)}</span>
            <span className="block font-sans text-[11.5px] text-[#5B6478]" data-id="element-7244" data-mp="726k9roxjz0c">{pick(v.insight.value)}</span>
            <span className="block font-sans text-[11.5px] text-[#5B6478]" data-id="element-7245" data-mp="btyfifj16swt">{pick(v.insight.trend)}</span>
          </span>
        </div>
        <ul className="mt-auto flex items-end gap-2 h-[42px] pl-7" aria-hidden="true" data-id="element-7246" data-mp="1wi95h74sarjy">
          {v.insight.bars.map((b, i) => <li key={i} className="flex-1 rounded-t-[2px]" style={{
        height: `${b}%`,
        background: i === v.insight.bars.length - 1 ? '#4F46E5' : '#DCDDFB'
      }} data-id="element-7247" data-mp="1riwimmdwxkhd" data-mpi={i} />)}
        </ul>
      </div>;
  if (k === 'notify') return <div className={`${BOX} p-3.5 h-[140px]`} data-id="element-7248" data-mp="1dk6ambpk20e8">
        <div className="flex items-center justify-between" data-id="element-7249" data-mp="1dn28k01ekp2o">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-[#EEEDFD] px-2 py-0.5 font-sans text-[10.5px] font-medium text-[#4F46E5]" data-id="element-7250" data-mp="18my458drrkst">
            <BellIcon className="w-3 h-3" aria-hidden="true" data-id="element-7251" data-mp="1ngswn3tmaxhu" />
            {pick(v.notify.tag)}
          </span>
          <span className="font-sans text-[10.5px] text-[#8A90A2]" data-id="element-7252" data-mp="2yyaszi8vcuuc">{pick(v.notify.time)}</span>
        </div>
        <p className="font-sans text-[12.5px] font-semibold text-[#121A3A] mt-2.5" data-id="element-7253" data-mp="2tzhkk48fvu11">{pick(v.notify.title)}</p>
        <p className="font-sans text-[11.5px] leading-snug text-[#5B6478] mt-0.5" data-id="element-7254" data-mp="13inkxhi4rwka">{pick(v.notify.text)}</p>
      </div>;
  if (k === 'pay') return <div className={`${BOX} p-3.5 h-[140px] flex flex-col`} data-id="element-7255" data-mp="18jb97vez5zat">
        <div className="flex items-center gap-3" data-id="element-7256" data-mp="1ci0su5qlwd2w">
          <span className="w-10 h-10 rounded-lg bg-[#F1F0FD] flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-7257" data-mp="1hhviy72k4ymw">
            <CreditCardIcon className="w-5 h-5 text-[#4F46E5]" strokeWidth={1.8} data-id="element-7258" data-mp="1mhhumc2qm6tl" />
          </span>
          <span data-id="element-7259" data-mp="1rfjidab3yube">
            <span className="block font-sans text-[12px] text-[#121A3A]" data-id="element-7260" data-mp="1rf1djpadr7rv">{pick(v.pay.title)}</span>
            <span className="block font-sans text-[14px] font-semibold text-[#121A3A]" data-id="element-7261" data-mp="1w7uiad5umg3y">{pick(v.pay.amount)}</span>
          </span>
        </div>
        <span className="mt-auto flex items-center justify-center gap-1.5 rounded-lg bg-[#4F46E5] py-2.5 font-sans text-[12px] font-medium text-white" data-id="element-7262" data-mp="20a7kwspatxwi">
          {pick(v.pay.cta)}
          <ArrowRightIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-7263" data-mp="2a6u297if26ts" />
        </span>
      </div>;
  const ACT_ICONS = {
    created: CheckCircle2Icon,
    assigned: ClipboardListIcon,
    tracking: Clock3Icon
  } as const;
  return <ul className={`${BOX} p-3.5 space-y-2.5`} data-id="element-7264" data-mp="2fdr492341d66">
      {v.act.map(a => {
      const Icon = ACT_ICONS[a.key];
      const done = a.key === 'created';
      return <li key={a.key} className="flex items-center gap-3" data-id="element-7265" data-mp="26cj7wpk5mmeq">
            <span className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${done ? 'bg-[#E8F6EF]' : 'bg-[#F1F0FD]'}`} aria-hidden="true" data-id="element-7266" data-mp="3318sinn61t4e">
              <Icon className={`w-4 h-4 ${done ? 'text-[#1F9D7A]' : 'text-[#4F46E5]'}`} strokeWidth={2} data-id="element-7267" data-mp="2y48kw8ao4ib6" />
            </span>
            <span className="min-w-0" data-id="element-7268" data-mp="2pa3wrwmx5kzc">
              <span className="block font-sans text-[12px] font-semibold text-[#121A3A]" data-id="element-7269" data-mp="2p92lbr1zqwh3">{pick(a.title)}</span>
              <span className="block font-sans text-[11px] text-[#5B6478] truncate" data-id="element-7270" data-mp="3lsrt6ntpwv39">{pick(a.sub)}</span>
            </span>
          </li>;
    })}
    </ul>;
}
export function ProductionCapabilities({
  isFR
}: P) {
  const pick = (b: Bi) => isFR ? b.fr : b.en;
  return <ol className="max-w-[1720px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-[1fr_auto_1fr_auto_1fr_auto_1fr_auto_1fr_auto_1fr] gap-x-4 gap-y-12" data-id="element-7271" data-mp="1k0zqtysbbflb">
      {capabilities.map((cap, i) => {
      const Icon = ICONS[cap.key];
      return <Fragment key={cap.key} data-id="element-7272" data-mp="wcgt2d6w2l7h" data-mpi={i}>
            <li className="flex flex-col" data-id="element-7273" data-mp="wb5fxmrk013p">
              <div className="flex items-start gap-3" data-id="element-7274" data-mp="11bjnz4t5nb1q">
                <span className="relative shrink-0" data-id="element-7275" data-mp="11de66bd1kp24">
                  <span className="absolute -top-2 -left-2 w-8 h-8 rounded-full bg-[#F1F0FD] flex items-center justify-center font-sans text-[12px] font-semibold text-[#4F46E5]" data-id="element-7276" data-mp="mf2b295bhod2">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="mt-4 ml-5 w-[58px] h-[58px] rounded-full bg-[#F1F0FD] flex items-center justify-center" aria-hidden="true" data-id="element-7277" data-mp="2gqh2qvhw1xvg">
                    <Icon className="w-6 h-6 text-[#4F46E5]" strokeWidth={1.7} data-id="element-7278" data-mp="a3rv9ambqt5w" />
                  </span>
                </span>
                <span className="min-w-0 pt-3" data-id="element-7279" data-mp="56j8sxu582yu">
                  <span className="block font-sans text-[16px] font-semibold leading-tight text-[#3F37C9]" data-id="element-7280" data-mp="ju4duxakwc9e">{pick(cap.title)}</span>
                  <span className="block font-sans text-[13px] leading-[1.5] text-[#5B6478] mt-2" data-id="element-7281" data-mp="f34dtj65xe2o">{pick(cap.text)}</span>
                </span>
              </div>
              <div className="mt-auto pt-5" data-id="element-7282" data-mp="ot7jaiuh0khw">
                <Visual k={cap.key} isFR={isFR} data-id="element-7283" data-mp="os5xpkftwflx" />
              </div>
            </li>
            {i < capabilities.length - 1 && <li className="hidden 2xl:flex items-start pt-16" aria-hidden="true" data-id="element-7284" data-mp="12qw45qojfrmy">
                <ChevronRightIcon className="w-6 h-6 text-[#4F46E5]" strokeWidth={2} data-id="element-7285" data-mp="xuf4bz7z7ou1" />
              </li>}
          </Fragment>;
    })}
    </ol>;
}